<div *ngIf="items$ | async as items" class="list-with-icons ms-large-b">
  <h3 class="mr-clear-t mr-medium-b">{{ (content$ | async)?.teaserTitle }}</h3>
  <ul>
    <li *ngFor="let item of items" class="flex flex--middle ms-medium-b">
      <span
        data-testid="list-with-icons-icon-wrapper"
        class="flex flex--center flex--middle mr-xsmall-r"
        [class.icon-circle]="!isNewBrand()"
        [ngClass]="{
          'white-text nordic-blue-900-bg': !isNewBrand(),
        }"
      >
        <fcom-icon [name]="item.iconName" *ngIf="item.iconName" />
      </span>
      <span
        class="nordic-blue-900-text text-icon-primary light-type font-body-1 font-body-medium"
        [innerHTML]="item.text"
      ></span>
    </li>
  </ul>
</div>
